import { createComponent } from "react-fela";

import WordpressLink from "~/components/global/links";
import { colors } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import Visual from "~/components/shared/visual";

export default function SubnavGroup({
    heading,
    items,
    isMobile,
    copy,
    second_heading,
    image,
    caption,
    link_content,
    isOverview,
    handleExit = () => {}
}) {

    // Support empty Wordpress headings on desktop
    if (
        heading.toLowerCase() === "menu item" ||
        heading.toLowerCase() === "empty"
    )
        heading = isMobile ? heading : "&nbsp;";

    return (
        <Container isMobile={isMobile} isOverview={isOverview}>
            {/* Second level menu is simply a Heading */}
            {((heading && !isMobile) || (isMobile && heading.length !== 1)) && (
                <HeadingLabel
                    isMobile={isMobile}
                    dangerouslySetInnerHTML={{
                        __html: heading
                    }}
                />
            )}

            {/* Third level menu is a Subnav Group */}
            <NavColumn
                className="nav-column">
                {isOverview && copy && <p className="subnav-link">{copy}</p>}

                {second_heading && !isMobile && (
                    <HeadingLabel
                        extend={MarginTop}
                        dangerouslySetInnerHTML={{
                            __html: second_heading
                        }}
                    />
                )}
                {isOverview && link_content && !isMobile &&
                    <a href={link_content}>
                        {image &&
                            <Visual
                                image={image}
                                background="cover"
                                aspect={23 / 8}
                                extend={MarginBottom}
                            />
                        }
                    </a>
                }
                {isOverview && caption && !isMobile && <p className="subnav-link">{caption}</p>}

                {!isOverview &&
                    items &&
                    items.map((grandchild, j) => {
                        const title = grandchild.title.trim();
                        const isInlineHeading = title
                            .toLowerCase()
                            .startsWith("<h>");

                        if (isInlineHeading) {
                            return (
                                <li key={j}>
                                    <HeadingLabel
                                        isMobile={isMobile}
                                        extend={inlineHeadingStyles(j)}
                                        dangerouslySetInnerHTML={{
                                            __html: title.slice(3).trim()
                                        }}
                                    />
                                </li>
                            );
                        }

                        const linkChunks = grandchild.title.split(":");
                        return (
                            <li
                                key={j}
                                className="nav-dropdown-item"
                            >
                                <WordpressLink
                                    url={grandchild.url}
                                    label={grandchild.title}
                                    skipLabel={true}
                                    extend={linkStyles}
                                    onClick={handleExit}
                                >
                                    <span
                                        className="subnav-link"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                linkChunks.length &&
                                                linkChunks[0].trim()
                                        }}
                                    ></span>
                                    {linkChunks.length > 1 && (
                                        <span
                                            className="subnav-subtitle"
                                            dangerouslySetInnerHTML={{
                                                __html: linkChunks[1].trim()
                                            }}
                                        />
                                    )}
                                </WordpressLink>
                            </li>
                        );
                    })}
            </NavColumn>
        </Container>
    );
}

const linkStyles = {
    whenActive: {
        "& .subnav-link": {
            color: colors.blue
        }
    }
};

const Container = createComponent(
    ({ isMobile, isOverview }) => ({
        width: "max-content",
        paddingLeft: 0,

        "& span": {
            display: "block"
        },

        "& .subnav-link": {
            color: colors.black,
            lineHeight: 1.3,
            extend: [
                fluid("font-size", { max: 18, min: 15 }),
                fluid("margin-bottom", { max: 8, min: 5 })
            ]
        },

        "& .subnav-subtitle": {
            color: colors.black,
            lineHeight: "normal",
            extend: [fluid("font-size", { max: 14, min: 12 })]
        },

        ":last-of-type": {
            paddingRight: 0
        },

        extend: [
            fluid("padding-right", { max: 72, min: 24 }),
            {
                condition: isMobile,
                style: {
                    width: "100%",
                    paddingLeft: 10,
                    "& li": {
                        lineHeight: "100%"
                    }
                }
            },
            {
                condition: !!isOverview,
                style: {
                    extend: [fluid("padding-right", { max: 85, min: 40 })],

                    "@media(min-width: 1268px)": {
                        flexShrink: 0,
                        width: 363
                    },
                    "@media(max-width: 1268px)": {
                        width: "25%"
                    }
                }
            }
        ]
    }),
    "ul"
);

const NavColumn = createComponent(() => ({
    "> li": {
        display: "block",
        marginBottom: 18
    },
    minWidthTablet: {
        "> li:last-of-type":{
            marginBottom: 0
        }
    }
}));

const HeadingLabel = createComponent(
    isMobile => ({
        color: colors.darkGrey,
        marginBottom: 30,
        lineHeight: "100%",
        fontWeight: "normal",
        display: "block",
        extend: [
            fluid("font-size", { max: 24, min: 18 }),
            {
                condition: isMobile,
                style: {
                    marginBottom: 15
                }
            }
        ]
    }),
    "h5",
    ["dangerouslySetInnerHTML"]
);
const MarginBottom = {
    marginBottom: 20
};
const MarginTop = {
    marginTop: 20
};

const inlineHeadingStyles = index => ({
    marginTop: index === 0 ? 0 : 30,
    marginBottom: 18
});
